import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStockInventory = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6665 33H3.13329C1.95511 33 1 32.0449 1 30.8667V3.13333C1 1.95513 1.95511 1 3.13329 1H18.2498C18.8152 1.00012 19.3574 1.22469 19.7573 1.62436L28.1085 9.97564C28.5081 10.3756 28.7327 10.9178 28.7328 11.4832V11.6667",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0664 1V9.53333C18.0664 10.7115 19.0215 11.6667 20.1997 11.6667H28.7329",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5513 13.598L8.51916 17.64C8.33356 17.8871 8.04988 18.0416 7.74157 18.0634C7.43327 18.0853 7.13065 17.9723 6.91208 17.7538L5.2666 16.1097",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5513 23.198L8.51916 27.24C8.33356 27.4871 8.04988 27.6416 7.74157 27.6634C7.43327 27.6852 7.13065 27.5723 6.91208 27.3537L5.2666 25.7082",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9331 18.0667H21.2663",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.1191 21.0804L21.2663 31.9334L15.9331 33L16.9998 27.6667L27.8525 16.8137C29.0272 15.6391 30.9316 15.6391 32.1063 16.8137L32.1191 16.8265C33.2937 18.0012 33.2937 19.9057 32.1191 21.0804Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgStockInventory);
export default ForwardRef;
